// InterventionIndex (03-dominio.md, RN37): which intervention a segment opens. It is a REVERSE lookup: from the row the user
// pressed to the intervention that cites it, never from an intervention's `imputationRowIds` to the lane (those ids may
// name rows that are not in `lanes.imputations`, RH-8 / E189-1).
const PRESENCE_TABLE = 'DEVICE_WORKER'
const JOB_TABLE = 'DEVICE_FABRICATION_ORDER'

/** A presence row opens the intervention anchored on it. Returns its index in `interventions`, or -1. */
export const interventionForPresence = (interventions, rowId) =>
  interventions.findIndex((intervention) => intervention.anchor.table === PRESENCE_TABLE && intervention.anchor.rowId === rowId)

/**
 * A clock-in WITH a job opens the job intervention of the SAME worker that cites it in `imputationRowIds` (the presence
 * intervention of that worker cites it too, and must not win). Returns its index, or -1.
 */
export const interventionForImputation = (interventions, workerId, rowId) =>
  interventions.findIndex((intervention) => intervention.anchor.table === JOB_TABLE &&
    intervention.worker.id === workerId && intervention.imputationRowIds.includes(rowId))

/** What identifies an intervention from one reading to the next (RN42): its anchor and its worker, never its position. */
export const identityOf = (intervention) => ({ table: intervention.anchor.table, rowId: intervention.anchor.rowId, workerId: intervention.worker.id })

/** The block and the intervention of a reading with that identity, or an empty object when the reading does not have it. */
export const findByIdentity = (blocks, { table, rowId, workerId }) => {
  for (const block of blocks) {
    const intervention = block.interventions.find((candidate) => candidate.anchor.table === table && candidate.anchor.rowId === rowId && candidate.worker.id === workerId)
    if (intervention) return { block, intervention }
  }
  return {}
}

/** The rows of a lane that an intervention highlights while it is selected (RN38): the ones in the lane, no more. */
export const highlightedRowIds = (intervention) =>
  intervention.anchor.table === PRESENCE_TABLE ? [intervention.anchor.rowId] : intervention.imputationRowIds

/** The lane an intervention is highlighted in: presence for a presence anchor, the worker's clock-ins otherwise. */
export const highlightedLaneKind = (intervention) => (intervention.anchor.table === PRESENCE_TABLE ? 'presence' : 'imputations')
